module.exports = __webpack_public_path__ + "img/Platform_Gradients-12.fe4a6a81.jpg";